// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  forwardRef,
  inject,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { v1 as uuidV1 } from 'uuid';
import { waitingTimer } from '../../../../helpers/_old_helpers/animate';
import { FilterDeletedPipe } from '../../../../pipes/filter-deleted.pipe';
import { EntityFieldsComponent } from '../../dynamic-form/sub-modules/sub-form/entity-fields/entity-fields.component';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../popup-feedback/popup-feedback.directive';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { FileFromProcessComponent } from '../file-from-process/file-from-process.component';
import { InputReferenceComponent } from '../input-reference/input-reference.component';
import { InputTextComponent } from '../input-text/input-text.component';
import { MonetarySemiFormComponent } from '../monetary-semi-form/monetary-semi-form.component';
import { FieldsGrid } from './grid-unique.model';

const booleanToString = (value) =>
  typeof value === 'boolean' || value === undefined ? String(value) : value;
const operations = {
  equal: (a, b) => booleanToString(a) === booleanToString(b),
  diff: (a, b) => booleanToString(a) !== booleanToString(b),
  isDefault: (a, b) => true,
  isNil: (value) => value === undefined || value === null,
  includes: (dynamicValue: string, templateValue: string[]) => templateValue.includes(dynamicValue),
};

@Component({
  selector: 'lbca-gridbox-unique',
  templateUrl: './gridbox-unique.component.html',
  styleUrl: './gridbox-unique.component.scss',
  imports: [
    forwardRef(() => MonetarySemiFormComponent),
    NgClass,
    InputTextComponent,
    InputReferenceComponent,
    DatePickerComponent,
    forwardRef(() => EntityFieldsComponent),
    FilterDeletedPipe,
    IconComponent,
    FileFromProcessComponent,
  ],
})
export class GridboxUniqueComponent {
  private overlay = inject(Overlay);
  private elementRef = inject(ElementRef);

  private popupFeedController = new PopupInterfaceCommunication();
  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );
  @ViewChild('mainElement', { static: true }) mainElement!: ElementRef;
  @ViewChild('templateRemove') templateRemove!: TemplateRef<any>;
  @ViewChild('templateCopy') templateCopy!: TemplateRef<any>;
  dataGrid: any[] = [];
  cols: any[] = [];
  error;
  readInputTimeOutDebounce;
  private fieldItem: any;
  public fieldConfiguration: any;
  singleDataList: any[] = [];
  public fieldList: any;
  public totalPagesValue = 0;
  public paginationType: 'next' | 'prev' | 'choose' | 'none' = 'next';
  public itensToExclude = ['financialCode', 'payValue', 'payValueUS'];
  public isLabeled = false;
  public isRequired = false;
  public isDisabled = false;
  public hideField = false;
  public helperTextValue = '';
  public labelValue = '';
  public valueInput!: string;
  public hasError = false;
  public isValid = false;
  public editControl = false;
  private defaultControl: any = {
    remove: false,
    confirmDelete: false,
    canEdit: true,
    canSend: false,
  };
  private errorPopup!: ErrorOverlayClass;
  public cardInfo: any;
  public data: any;

  @Input() enableLogicalDeletion: boolean = false;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }
  @Input()
  set configuration(val) {
    this.fieldConfiguration = val;
    // keyList é a atribuição { "entityKey": null }
    this.fieldConfiguration.keyList = Object.assign(
      {},
      ...this.fieldConfiguration.primary.map((keyList) => ({ [keyList.entityKey]: null }))
    );
  }
  @Input() set field(val) {
    this.fieldItem = val;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = value;
  }
  @Input() set totalPages(totalPages: number) {
    this.totalPagesValue = totalPages;
  }

  @Input('entityData') set modulesConfig(data) {
    this.data = data;
  }

  @Input()
  set value(val: any) {
    const keyList = this.fieldConfiguration.keyList;
    if (val) {
      this.singleDataList = val.map((item, index) => ({
        index,
        ...item,
        ...this.defaultControl,
        config: this.generateConfig(item),
      }));
    } else {
      const edited = this.defaultControl;
      edited.canEdit = true;
      const firstItem = {
        id: uuidV1(),
        deleted: false,
        index: 0,
        ...edited,
        ...keyList,
        config: JSON.parse(JSON.stringify(this.fieldConfiguration.primary)),
      };
      for (const key in keyList) {
        firstItem[key] = this.fieldConfiguration?.primary.find(
          (item) => item.entityKey === key
        )?.defaultValue;
      }

      this.singleDataList = [firstItem];
    }
  }
  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
    this.error = error;
  }
  @Output('setError') errorStateEmmiter = new EventEmitter();
  @Output('validState') validStatusEmmiter = new EventEmitter();
  @Output('changeValue') changeValueEmmiter = new EventEmitter();
  @Output('selectedPage') selectedPageValueEmmiter = new EventEmitter<number>();
  constructor() {
    const overlay = this.overlay;
    const elementRef = this.elementRef;

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'start'
    );
  }

  newItem(): any {
    const fields: any[] = [];
    this.fieldConfiguration.primary.forEach((element: any) => fields.push({ ...element }));
    const id = uuidV1();
    const classFields = new FieldsGrid(fields, id);

    return classFields.fields;
  }
  public newField(): void {
    this.fieldList = this.newItem();

    const keyList = this.fieldConfiguration.keyList;
    const edited = this.defaultControl;
    edited.canEdit = true;

    const newItem = {
      id: uuidV1(),
      deleted: false,
      index: this.singleDataList.length,
      ...keyList,
      ...edited,
      config: JSON.parse(JSON.stringify(this.fieldConfiguration.primary)),
    };

    for (const key in keyList) {
      newItem[key] = this.fieldConfiguration?.primary.find(
        (item) => item.entityKey === key
      )?.defaultValue;
    }

    this.singleDataList = [...this.singleDataList, newItem];
  }

  public async removeFromArray($event, item): Promise<void> {
    if (this.enableLogicalDeletion) {
      item.deleted = !item.deleted;
    } else {
      item.confirmDelete = !item.confirmDelete;
    }
    await waitingTimer(700);

    if (!this.enableLogicalDeletion)
      this.singleDataList = this.singleDataList.filter((item: any) => item.confirmDelete === false);

    await this.reIndex();
    this.sendItens();
    if (this.singleDataList.length === 0) this.newItem();
    this.popupFeedController.show(this.templateRemove);
    await waitingTimer(2000);
    this.popupFeedController.close();
  }

  async reIndex() {
    await this.singleDataList.forEach((item, index) => (item.index = index));
  }
  confirmDeleteItem($event, row) {
    row.remove = !row.remove;
  }
  // config: JSON.parse(JSON.stringify(this.fieldConfiguration.primary)) }
  public generateConfig(item) {
    const config = JSON.parse(JSON.stringify(this.fieldConfiguration.primary));

    config.forEach((field) => {
      const value = item[field.entityKey];

      if (field?.dependency?.conditions) {
        field.dependency.conditions.forEach((cond) => {
          const op = operations[cond.op];

          if (op && op(value, cond.value)) {
            for (const children in cond.overwrite) {
              const element = config.find((item) => item.entityKey === children);

              if (element) {
                for (const key in cond.overwrite[children]) {
                  if (key === 'clearValue') {
                    continue;
                  }
                  element[key] = cond.overwrite[children][key];
                }
              }
            }
          }
        });
      }
    });
    return config;
  }

  public changeField(value, field, index): void {
    if (field?.dependency?.conditions) {
      field.dependency.conditions.forEach((cond) => {
        const op = operations[cond.op];

        if (op && op(value, cond.value)) {
          for (const children in cond.overwrite) {
            const field = this.singleDataList[index].config.find(
              (item) => item.entityKey === children
            );

            if (field) {
              for (const key in cond.overwrite[children]) {
                if (key === 'clearValue') {
                  this.singleDataList[index][children] = '';
                  continue;
                }
                field[key] = cond.overwrite[children][key];
              }
            }
          }
        }
      });
    }

    this.singleDataList[index][field.entityKey] = value;
  }

  public changeFieldSemiForm(value, index): void {
    this.singleDataList[index][value.entityKey] = value.value;
    this.sendItens();
  }

  public sendItens() {
    const data = JSON.parse(JSON.stringify(this.singleDataList));
    if (!data) return;
    const finalDataToSend: any = [];
    data.forEach((item) => {
      let send = true;

      item.config.forEach((config) => {
        if (config.entityKey && !item[config.entityKey]) {
          if (!item[config.entityKey]) return;
          send = false;
        } else if (config.type === 'MONETARY_SEMI_FORM') {
          send = true;
        }
      });

      if (send) {
        finalDataToSend.push(
          (({ canEdit, remove, confirmDelete, index, config, ...output }: any) => output)(item)
        );
      }
    });
    this.changeValueEmmiter.emit(finalDataToSend);
    this.isValid = false;
    this.hasError = false;
  }
  public focusState($event, item): void {
    if (!$event) {
      // reset da marcação seguinte
      // for(let index=0; index<this.singleDataList.length; index++){
      //   this.singleDataList[index].canSend = true;
      // }
      // // this.singleDataList.map((reset) => (reset.canSend = true));
      // //marcando campos incompletos de preenchimento para não passar para o back e permitir edição
      // for(let index=0; index<this.fieldConfiguration.primary.length; index++){
      //   if (item[this.fieldConfiguration.primary[index].entityKey] === null || !item[this.fieldConfiguration.primary[index].entityKey]) {
      //     item.canSend = false;
      //   }
      // }
      // this.fieldConfiguration.primary.map((keyList) => {
      //   if (item[keyList.entityKey] === null || !item[keyList.entityKey]) {
      //     item.canSend = false;
      //   }
      // });
      // Qual o sentido de não poder editar quando tem erro???
      // this.singleDataList.find( itemIndex => itemIndex.index === item.index).canEdit = this.hasError || !item.canSend;
      this.sendItens();
    }
  }
  public mouseenter(): void {
    this.errorPopup.setFocus(true);
  }
  public mouseleave(): void {
    this.errorPopup.setFocus(false);
  }
  public setErrorState($event, field) {
    this.errorStateEmmiter.emit($event);
    this.hasError = Array.isArray($event) ? $event.length > 0 : !!$event;
  }
  public setValidState($event, field) {
    this.validStatusEmmiter.emit($event);
    this.isValid = $event;
  }

  saveUpload($event) {
    const file = $event;
    const context = file.context;
    const entityKey = file.entityKey;
    const value = context; //file.deleted === 1 ? null : context;

    this.fieldList.forEach((mainData) => {
      if (!mainData.fields) {
        if (mainData.entityKey === entityKey) {
          mainData.value = value;
        }
      } else {
        mainData.fields.forEach((fieldList) => {
          if (Array.isArray(fieldList)) {
            fieldList.forEach((fieldListByRow) => {
              if (fieldListByRow.entityKey === entityKey) {
                fieldListByRow.value = value;
              }
            });
          } else {
            if (fieldList.entityKey === entityKey) {
              fieldList.value = value;
            }
          }
        });
      }
    });
  }
}
